(function ($)
{
    $.widget("ui.JobBoardBlock",
    {
        options:
        {
            PageContentId: null,
            NavigationUrl: "/Core/JobBoards/Block/",
            LoadingHTML: '<div>'
                + '<img class="loading_image" src="/img/ajax_loading.gif" alt="Loading JobBoard Block..." title="Loading Job Board Block..."/>'
                + '<div class="message_text">Loading Job Board Block...</div>'
                + '</div>',
            ErrorHTML: '<div>'
                + '<img class="error_image" src="/img/ajax_error.gif" alt="Error Loading JobBoard Block." title="Error Loading Job Board Block."/>'
                + '<div class="message_text">Error Loading Job Board Block.</div>'
                + '</div>',
            LoadingClass: 'jobboard_loading',
            OverlayClass: 'jobboard_overlay',
            OverlayLoadingClass: 'overlay_loading',
            OverlayErrorClass: 'overlay_error',
            JobBoardRedirectUrl: null,
            JobBoardClickSelector: '.jobboard_title,.jobboard_thumbnail,.jobboard_largeimage'
        },

        ContentId: null,
        
        _destroy: function ()
        {
        },

        _init: function ()
        {           
        },

        _create: function ()
        {
            var self = this;
            var jElement = $(self.element);
            
            self.ContentId = self.options.PageContentId;
            
            jElement.on(
                'click',
                self.options.JobBoardClickSelector,
                function(aEvent)
                {
                    var lMenuItem = $(aEvent.target).parents('.jobboard');
                    if (lMenuItem.length !== 1)
                    {
                        return false;
                    }
                    var lJobBoardTitleLink = lMenuItem.find('.jobboard_title[data-href]');
                    var lNewPageUrl = null;
                    if (lJobBoardTitleLink.length === 1)
                    {
                        lNewPageUrl = lJobBoardTitleLink.data('href');
                    }
                    var lJobBoardId = lMenuItem.data('jobboard-id');
                    if (!FBUtilities.IsParameterUndefinedOrNull(lJobBoardId)
                        && !FBUtilities.IsParameterUndefinedOrNull(self.options.JobBoardRedirectUrl))
                    {
                        lNewPageUrl = self.options.JobBoardRedirectUrl + '?JobBoardId=' + lJobBoardId;
                    }
                    if (!FBUtilities.IsStringEmptyOrWhitespace(lNewPageUrl))
                    {
                        window.location.href = lNewPageUrl;
                    }
                    return false;
                }
            );
            
            self._InitClickSelectorElements();
        },
        
        _InitClickSelectorElements: function()
        {
            var self = this;
            var jElement = $(self.element);
        
            var lJobBoardsSelectElements = jElement.find(self.options.JobBoardClickSelector);
            lJobBoardsSelectElements.css('cursor','pointer');
            lJobBoardsSelectElements.attr('tabindex','0');
        },
        
        _UseJobBoardRedirect: function()
        {
            var self = this;
            var jElement = $(self.element);
            
            if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.JobBoardClickSelector)
                && !FBUtilities.IsStringEmptyOrWhitespace(self.options.JobBoardRedirectUrl))
            {
                return true;
            }
            return false;
        },
        
        GetJobBoardId: function ()
        {
            var self = this;
            var jElement = $(self.element);
            
            var lCurrentJobBoard = jElement.find('.jobboard');
            
            if (lCurrentJobBoard.length !== 1)
            {
                return null;
            }
            
            return lCurrentJobBoard.data('jobboard-id');
        },
        
        LoadJobBoard: function (aJobBoardId, aCallbacks, aTransitionSpeed)
        {
            var self = this;
            var jElement = $(self.element);
            
            if (FBUtilities.IsParameterUndefinedOrEmpty(aJobBoardId))
            {
                return;
            }
            
            var lCurrentJobBoard = jElement.find('.jobboard');
            
            //ok, do we nuke the current content even if we find nothing?
            self.DisplayLoadingOverlay();

            $.ajax(self.options.NavigationUrl + self.ContentId + '?JobBoardId=' + aJobBoardId, 
            {
                success: function (aData, aTextStatus, aJqXHR)
                {
                    self.AnimateNewData(
                        lCurrentJobBoard,
                        aData,
                        function()
                        {
                            self._InitClickSelectorElements();
                            self.ClearOverlay();

                            FBUtilities.RunCallback(aCallbacks, 'OnSuccess', self.GetJobBoardId());
                            jElement.find( '.vp_share_panel' ).ShareLink( {} );
                        },
                        aTransitionSpeed
                    );
                },
                error: function (aJqXHR, aTextStatus, aErrorThrown)
                {
                    self.DisplayErrorOverlay();
                },
                complete: function (aJqXHR, aTextStatus, aErrorThrown)
                {
                    FBUtilities.RunCallback(aCallbacks, 'OnComplete');
                },
                type: 'POST'
            });
        },
        
        AnimateNewData: function(aCurrentElement, aNewData, aOnComplete, aTransitionSpeed)
        {
            var self = this;
            var jElement = $(self.element);
        
            var lTransitionSpeed = parseInt(aTransitionSpeed);
            var lFadeOutSpeed = 0;
            var lFadeInSpeed = 0;
            if (!isNaN(lTransitionSpeed)
                && lTransitionSpeed > 0)
            {
                lFadeOutSpeed = (lTransitionSpeed/2);
                lFadeInSpeed = (lTransitionSpeed/2);
            }
            
            aCurrentElement.fadeOut(
                lFadeOutSpeed, 
                function()
                {
                    var lData = $($.parseHTML(aNewData.toString().trim()));
                    lData.hide();
                    $(this).replaceWith(lData);
                    lData.fadeIn(
                        lFadeInSpeed,
                        aOnComplete
                    );
                }
            );
        },
        
        DisplayLoadingOverlay: function()
        {
            var self = this;
            var jElement = $(self.element);
            
            if (jElement.hasClass(self.options.LoadingClass))
            {
                return;
            }
            jElement.addClass(self.options.LoadingClass);
            var lLoadingHtml = $('<div></div>');
            lLoadingHtml.addClass(self.options.OverlayClass);
            lLoadingHtml.addClass(self.options.OverlayLoadingClass);
            lLoadingHtml.html(self.options.LoadingHTML);
            jElement.append(lLoadingHtml);
        },
        
        DisplayErrorOverlay: function()
        {
            var self = this;
            var jElement = $(self.element);
            
            if (!jElement.hasClass(self.options.LoadingClass))
            {
                jElement.addClass(self.options.LoadingClass);
            }
            
            var lErrorHtml = $('<div></div>');
            lErrorHtml.addClass(self.options.OverlayClass);
            lErrorHtml.addClass(self.options.OverlayErrorClass);
            lErrorHtml.html(self.options.ErrorHTML);
            
            var lOverlay = jElement.find('.' + self.options.OverlayClass);
            if (lOverlay.length !== 0)
            {
                lOverlay.replaceWith( lErrorHtml );
            }
            else
            {
                jElement.append(lErrorHtml);
            }
        },
        
        ClearOverlay: function()
        {
            var self = this;
            var jElement = $(self.element);
            
            jElement.removeClass(self.options.LoadingClass);
            var lOverlay = jElement.find('.' + self.options.OverlayClass);
            if (lOverlay.length !== 0)
            {
                lOverlay.remove();
            }
        }
    });
})(jQuery);
